export const description = {
  faster:
    "ผลลัพธ์นี้เกิดจากคะแนนของคุณที่อยู่ในเกณฑ์สูงกว่าค่าเฉลี่ยของคนในวัยเดียวกัน",
  same: "ผลลัพธ์นี้เกิดจากคะแนนของคุณที่อยู่ในเกณฑ์เดียวกันกับค่าเฉลี่ยของคนในวัยเดียวกัน",
  slower:
    "ผลลัพธ์นี้เกิดจากคะแนนของคุณที่อยู่ในเกณฑ์ต่ำกว่าค่าเฉลี่ยของคนในวัยเดียวกัน",
};
